import { render } from "./VisitCalendar.vue?vue&type=template&id=4dd49e52"
import script from "./VisitCalendar.vue?vue&type=script&lang=js"
export * from "./VisitCalendar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__